import { ClientParams } from '../localeParams'

export const clientEN: ClientParams = [
  ') Check Validator Status',
  ') Download Validator Keyfiles',
  ') Generate Validator Keyfiles',
  ') Upload Validator Keyfiles',
  ') Set Validator Keyfile/Network',
  ') Uninstall',
  ') Exit',
]

export const clientSubEN = [[]]
